import React from 'react';
import { Container } from 'reactstrap';

import GenericLayout from '../../components/layout/GenericLayout';
import ManufacturerListPageSkeleton from '../../components/skeleton/ManufacturerListPageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const MANUFACTURER_LIST_PAGE_CHUNK_NAME = 'manufacturerListPage';

export const ManufacturerListPageFallback = () => (
  <Container className="ManufacturerListPage__container">
    <GenericLayout content={<ManufacturerListPageSkeleton />} />
  </Container>
);

export const ManufacturerListPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "manufacturerListPage" */ '../../pages/ManufacturerListPage'
    ),
  {
    fallback: <ManufacturerListPageFallback />,
  }
);
